import { useNavigate } from 'react-router-dom'


const useGoBack = (fallbackPath = '/') => {
  const navigate = useNavigate()

  const goBack = () => {
    // Check if there is a previous entry in the history stack created by the router
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1) // Go back to the previous page
    } else {
      navigate(fallbackPath) // Redirect to fallback if no history exists
    }
  }

  return goBack
}

export default useGoBack
